import React from 'react';
import { withTranslation } from 'react-i18next';
import classNames from 'classnames';
import './index.scss';

import { getRestaurantPaymentEnabled } from '../../../services/restaurant';
import { USER_ROLES } from '../../../utils/enums';

import RoleAvatar from '../RoleAvatar';
import ColumnTitleWithIcon from '../ColumnTitleWithIcon';
import {defaultRoleSelectorConfig} from "../../../utils/constants";

const SectionItemRoleSelector = ({ t, column, item, onPropChange }) => {
    const config = column.config || defaultRoleSelectorConfig;
    return (
        <div className={classNames('sectionItemRoleSelector')}>
            <ColumnTitleWithIcon item={item} column={column} onPropChange={onPropChange} />
            <div className={classNames('roleSelectors')}>
                {config[USER_ROLES.controlCenterManager] && <RoleAvatar
                    role={USER_ROLES.controlCenterManager}
                    active={item[column.accessor] && item[column.accessor][USER_ROLES.controlCenterManager]}
                    unapproved={false}
                    tooltipText={t('settings.users.USER_ROLE_CONTROL_CENTER_MANAGER_TOOLTIP')}
                    onRoleClick={() =>
                        onPropChange({
                            [column.accessor]: {
                                ...item[column.accessor],
                                [USER_ROLES.controlCenterManager]: !item[column.accessor][USER_ROLES.controlCenterManager],
                            },
                        })
                    }
                />}
                {config[USER_ROLES.deliveryManager] && <RoleAvatar
                    role={USER_ROLES.deliveryManager}
                    active={item[column.accessor] && item[column.accessor][USER_ROLES.deliveryManager]}
                    unapproved={false}
                    tooltipText={t('settings.users.USER_ROLE_MANAGER_TOOLTIP')}
                    onRoleClick={() =>
                        onPropChange({
                            [column.accessor]: {
                                ...item[column.accessor],
                                [USER_ROLES.deliveryManager]: !item[column.accessor][USER_ROLES.deliveryManager],
                            },
                        })
                    }
                />}
                {config[USER_ROLES.courier] && <RoleAvatar
                    role={USER_ROLES.courier}
                    active={item[column.accessor] && item[column.accessor][USER_ROLES.courier]}
                    unapproved={false}
                    tooltipText={t('settings.users.USER_ROLE_COURIER_TOOLTIP')}
                    onRoleClick={() =>
                        onPropChange({
                            [column.accessor]: {
                                ...item[column.accessor],
                                [USER_ROLES.courier]: !item[column.accessor][USER_ROLES.courier],
                            },
                        })
                    }
                />}
                {config[USER_ROLES.supervisor] && <RoleAvatar
                    role={USER_ROLES.supervisor}
                    active={item[column.accessor] && item[column.accessor][USER_ROLES.supervisor]}
                    unapproved={false}
                    tooltipText={t('settings.users.USER_ROLE_SUPERVISOR_TOOLTIP')}
                    onRoleClick={() =>
                        onPropChange({
                            [column.accessor]: {
                                ...item[column.accessor],
                                [USER_ROLES.supervisor]: !item[column.accessor][USER_ROLES.supervisor],
                            },
                        })
                    }
                />}
                {getRestaurantPaymentEnabled() && config[USER_ROLES.supportOperator] &&(
                    <RoleAvatar
                        role={USER_ROLES.supportOperator}
                        active={item[column.accessor] && item[column.accessor][USER_ROLES.supportOperator]}
                        unapproved={false}
                        tooltipText={t('settings.users.USER_ROLE_SUPPORT_OPERATOR_TOOLTIP')}
                        onRoleClick={() =>
                            onPropChange({
                                [column.accessor]: {
                                    ...item[column.accessor],
                                    [USER_ROLES.supportOperator]: !item[column.accessor][USER_ROLES.supportOperator],
                                },
                            })
                        }
                    />
                )}
            </div>
        </div>
    )
}

export default withTranslation()(SectionItemRoleSelector);
